export default {
    methods: {
        cleanText(text) {
            return text ? String(text).replace(/\u200B/g, '').trim() : '';
        },
        getDisplayText(text) {
            return text || (this.enableInlineEdit ? ' ' : '');
        },
        syncEditableText(refName, newVal) {
            if (this.enableInlineEdit && this.$refs[refName]) {
                const element = this.$refs[refName];
                const currentText = element.textContent || '';
                const cleanedCurrent = this.cleanText(currentText);
                const cleanedNew = this.cleanText(newVal);
                
                if (cleanedCurrent !== cleanedNew) {
                    this.$nextTick(() => {
                        if (this.$refs[refName]) {
                            this.$refs[refName].textContent = cleanedNew || ' ';
                        }
                    });
                }
            }
        },
        syncButtonTextContent(index, displayText) {
            if (!this.enableInlineEdit) return;
            
            const buttonRef = this.$refs[`buttonRef${index}`];
            const buttonEl = Array.isArray(buttonRef) ? buttonRef[0] : buttonRef;
            if (!buttonEl) return;
            
            const currentText = buttonEl.textContent || '';
            const cleanedCurrent = this.cleanText(currentText);
            const cleanedNew = this.cleanText(displayText);
            
            if (cleanedCurrent !== cleanedNew) {
                this.$nextTick(() => {
                    const buttonRefCheck = this.$refs[`buttonRef${index}`];
                    const buttonElCheck = Array.isArray(buttonRefCheck) ? buttonRefCheck[0] : buttonRefCheck;
                    if (buttonElCheck) {
                        buttonElCheck.textContent = cleanedNew || ' ';
                    }
                });
            }
        },
        syncLabelTextContent(index, displayText) {
            if (!this.enableInlineEdit) return;
            
            const labelRef = this.$refs[`labelRef${index}`];
            const labelEl = Array.isArray(labelRef) ? labelRef[0] : labelRef;
            if (!labelEl) return;
            
            const currentText = labelEl.textContent || '';
            const cleanedCurrent = this.cleanText(currentText);
            const cleanedNew = this.cleanText(displayText);
            
            if (cleanedCurrent !== cleanedNew) {
                this.$nextTick(() => {
                    const labelRefCheck = this.$refs[`labelRef${index}`];
                    const labelElCheck = Array.isArray(labelRefCheck) ? labelRefCheck[0] : labelRefCheck;
                    if (labelElCheck) {
                        labelElCheck.textContent = cleanedNew || ' ';
                    }
                });
            }
        }
    }
};
